/**
 * Abgehakte Zeilen von „Heute wichtig“ (Ticket 1.275, S2/S8 „abhaken“): Es gibt keinen Server-Command dafür – der Haken
 * ist eine Bedienhilfe im Browser je Person und fachlichem Tag (Muster `sidebar-part.ts`). Ein neuer Tag beginnt ohne
 * Haken (Schlüssel mit dem Tag); beim Schreiben werden Haken früherer Tage derselben Person entfernt. Ohne Speicher
 * (privates Fenster) gilt der Haken bis zum Neuladen. Beim Abmelden löscht `clearPersonalCaches()` alles
 * (`clearBriefingDone`).
 */

const STORAGE_PREFIX = 'till-erp.heute-wichtig.';

function userPrefix(userId: string): string {
  return `${STORAGE_PREFIX}${userId}.`;
}

function key(userId: string, day: string): string {
  return `${userPrefix(userId)}${day}`;
}

/** Kennungen der abgehakten Zeilen dieser Person an diesem fachlichen Tag (`YYYY-MM-DD`); ohne Speicher leer. */
export function readBriefingDone(userId: string, day: string): string[] {
  try {
    const raw = window.localStorage.getItem(key(userId, day));
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : [];
  } catch {
    return [];
  }
}

/** Abgehakte Zeilen merken (Reihenfolge = Reihenfolge des Abhakens); Haken früherer Tage derselben Person entfallen. */
export function writeBriefingDone(userId: string, day: string, ids: readonly string[]): void {
  try {
    const storage = window.localStorage;
    for (const k of Object.keys(storage)) if (k.startsWith(userPrefix(userId)) && k !== key(userId, day)) storage.removeItem(k);
    if (ids.length === 0) storage.removeItem(key(userId, day));
    else storage.setItem(key(userId, day), JSON.stringify(ids));
  } catch {
    // Ohne Speicher gilt der Haken bis zum Neuladen.
  }
}

/** Alle Haken vergessen (Abmelden, Personenwechsel). */
export function clearBriefingDone(): void {
  try {
    for (const k of Object.keys(window.localStorage)) if (k.startsWith(STORAGE_PREFIX)) window.localStorage.removeItem(k);
  } catch {
    // Ohne Speicher gibt es nichts zu löschen.
  }
}
